import { useWatch } from 'react-hook-form';

import { useJobPostingContext } from '@/contexts/job-posting-context';
import { POOL } from '@/types/channels';

import { ChannelForm } from './channel-form';
import { ChannelFormProvider } from './channel-form-context';
import { ChannelSummary } from './channel-summary';
import { PoolForm } from './pool-form';

function ChannelEntry({ channelKey }: { channelKey: string }) {
  const { hookForm } = useJobPostingContext();
  const isExpanded = useWatch({
    control: hookForm.control,
    name: `channels.${channelKey}.isExpanded`,
  });
  const slug = useWatch({
    control: hookForm.control,
    name: `channels.${channelKey}.slug`,
  });

  if (slug === POOL) {
    return <PoolForm />;
  }

  return isExpanded ? (
    <ChannelForm channelKey={channelKey} />
  ) : (
    <ChannelSummary channelKey={channelKey} />
  );
}

export function CampaignDetails() {
  const { hookForm } = useJobPostingContext();
  const channelsFormData = useWatch({
    control: hookForm.control,
    name: 'channels',
  });

  return (
    <>
      {Object.keys(channelsFormData).map(channelKey => (
        <ChannelFormProvider key={channelKey} channelKey={channelKey}>
          <ChannelEntry channelKey={channelKey} />
        </ChannelFormProvider>
      ))}
    </>
  );
}
